// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2A5sl","col":"Table_col__1fYdb","fulfillmentStatus":"Table_fulfillmentStatus__Z7vP-","emailCol":"Table_emailCol__rYHQ1"};